const EVENT_PREFIX = 'sanitas_chat-enduser_'

export const EVENT = {
  LISTEN_TO: {
    CHECK_UNREAD_MESSAGES: `${EVENT_PREFIX}check-unread-messages`,
    DESTROY: `${EVENT_PREFIX}destroy`,
    OPEN: `${EVENT_PREFIX}open`,
    SET_LANGUAGE: `${EVENT_PREFIX}set-language`,
    SHOW_FAB: `${EVENT_PREFIX}show-fab`,
    TRIGGER_NUDGING: `${EVENT_PREFIX}trigger-nudging`,
    UPDATE_BASKET: `${EVENT_PREFIX}update-basket`
  },
  SEND: {
    CONVERSATION_ENDED: `${EVENT_PREFIX}conversation-ended`,
    CONVERSATION_STARTED: `${EVENT_PREFIX}conversation-started`,
    CLOSE: `${EVENT_PREFIX}close`,
    KEEP_ALIVE: `${EVENT_PREFIX}keep-alive`,
    MINIMIZE: `${EVENT_PREFIX}minimize`,
    NEW_UNREAD_MESSAGE: `${EVENT_PREFIX}new-unread-message`,
    OPENED: `${EVENT_PREFIX}opened`,
    TRIGGER_NUDGING: `${EVENT_PREFIX}trigger-nudging`
  }
}

const OLD_EVENTS_MAPPING = {
  LISTEN_TO: {
    'sanitas_kupo-logout': EVENT.LISTEN_TO.DESTROY,
    'sanitas_chat-enduser_language': EVENT.LISTEN_TO.SET_LANGUAGE,
    'sanitas_kupo-login': EVENT.LISTEN_TO.SHOW_FAB,
    'sanitas_ovp-basket_updated': EVENT.LISTEN_TO.UPDATE_BASKET,
    'sanitas_chat-trigger_nudging': EVENT.LISTEN_TO.TRIGGER_NUDGING
  },
  SEND: {
    'sanitas-chat_close': EVENT.SEND.CLOSE,
    'sanitas_chat-keepalive': EVENT.SEND.KEEP_ALIVE,
    'sanitas-chat_minimize': EVENT.SEND.MINIMIZE,
    'sanitas_chat-trigger_nudging': EVENT.SEND.TRIGGER_NUDGING
  }
}

const getEventIds = (eventId, mapping) => [
  eventId,
  ...Object.entries(mapping)
    // eslint-disable-next-line
    .filter(([_, newEventId]) => newEventId === eventId)
    .map(([oldEventId]) => oldEventId)
]

export const listenToCustomEvent = (eventId, callback) => {
  const eventIds = getEventIds(eventId, OLD_EVENTS_MAPPING.LISTEN_TO)
  
  eventIds.forEach(_eventId => {
    console.debug('listening to event', _eventId)
    window.addEventListener(_eventId, event => {
      console.debug(`custom event ${_eventId} triggered!`)
      
      if (Object.keys(OLD_EVENTS_MAPPING.LISTEN_TO).includes(_eventId)) {
        console.warn(`Event ${_eventId} is deprecated!`)
      }
      
      callback(event)
    })
    window.addEventListener(_eventId, callback)
  })
}

export const dispatchCustomEvent = (eventId, payload = {}) => {
  const eventIds = getEventIds(eventId, OLD_EVENTS_MAPPING.SEND)
  
  eventIds.forEach(eventId => {
    console.debug('dispatching custom event', eventId, 'with payload', payload)
    window.dispatchEvent(new CustomEvent(eventId, payload))
  })
}